import { render, staticRenderFns } from "./ExchangeStatus.vue?vue&type=template&id=61b8bdc4&scoped=true"
import script from "./ExchangeStatus.vue?vue&type=script&lang=js"
export * from "./ExchangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8bdc4",
  null
  
)

export default component.exports